import {ProductViewMode} from '@/pages/retailers/dashboard/types/competitive-analysis.types';

export default function ProductViewToggle({
  viewMode,
  onChange,
}: {
  viewMode: ProductViewMode;
  onChange: (mode: ProductViewMode) => void;
}) {
  return (
    <div className="flex items-center space-x-4 rounded-lg bg-black p-1 shadow-sm">
      <button
        onClick={() => onChange('verified')}
        className={`rounded-sm px-4 py-2 text-sm font-medium ${
          viewMode === 'verified' ? 'bg-primary text-white' : 'text-gray-500 hover:bg-primary'
        }`}
      >
        Verified Products
      </button>
      <button
        onClick={() => onChange('unverified')}
        className={`rounded-sm px-4 py-2 text-sm font-medium ${
          viewMode === 'unverified' ? 'bg-primary text-white' : 'text-gray-500 hover:bg-primary'
        }`}
      >
        Unverified Products
      </button>
      <button
        onClick={() => onChange('all')}
        className={`rounded-sm px-4 py-2 text-sm font-medium ${
          viewMode === 'all' ? 'bg-primary text-white' : 'text-gray-500 hover:bg-primary'
        }`}
      >
        All Products
      </button>
    </div>
  );
}
